import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import JsonApi from "./jsonApi";
import {renderErrorPopup} from "./api-popups";
import store from "../store";
import {
  contractSignPostSignature,
  setAfterContractSignCallback,
  setContractDocumentForJob
} from "../actions/contractsActions";
// import {getCurrentReceipt} from "../actions/printFunctions";
import {ConfirmPopupTypes} from "../bvcomponents/visComponents/constants";
import {getCurrentReceiptPages} from "../actions/printFunctions";
import {saveQuote} from "./server-api";
import {IS_AS_WORK_ORDER, IS_OFFLINE_MODE} from "../config";
import Analytics from "../analytics";
import {showOrderCompletePopup} from "../actions/shoppingCartFunctions";
// import {saveQuote} from "./server-api";
// import {showQuoteSavedNotification} from "../bvcomponents/ui/successNotification";

// not USED!!
export const postContractSign = async ({firstName, lastName, custom, signaturePngBase64, offlineRetryCallback}) => {

  const {contractSigningState} = store.getState();

  let needToChangeFields = false;
  if (!document.kvConfig.jobId && contractSigningState.afterContractSignCallback) {
    needToChangeFields = true;
    try {
      const responseSaveQuote = await contractSigningState.afterContractSignCallback();
      console.log("responseSaveQuote", responseSaveQuote);

      if (responseSaveQuote) {
        store.dispatch(setAfterContractSignCallback(null)); // erase it, it's ok now
      } else {
        setTimeout(() => {
          const {userState} = store.getState();
          if (!(userState.confirmPopupOpened && userState.confirmPopupType === ConfirmPopupTypes.AssignQuoteOnExistingUser)) {
            renderErrorPopup("Network Error", "", offlineRetryCallback); // overwrite existing popup!
          }
        }, 0)
        return // do not go further, quote is not saved
      }
    } catch (error) {
      renderErrorPopup(error, "", offlineRetryCallback);
      loaderDisable();
      return // do not go further, quote is not saved
    }
  }

  // подумай, как сохранить квоту и потом подвязать пдф рисипт к текузему контракту!

  loaderEnable("loader.contractSignText", "loader.contractSignTitle");

  const {userState, serverState} = store.getState();

  let postData = {
    fabricatorId: document.kvConfig.userId,
    jobId: document.kvConfig.jobId || serverState.jobId || 265603,
    customerEmail: userState.userInfo.email,
    replacements: {
      firstName,
      lastName,
      custom,
    },
    customFieldValues: contractSigningState.pagesCustomFieldsValue,
    signaturePngBase64,
    contractFieldValuesOnly: contractSigningState.jobDocumentUrl.includes("blob:")
  };

  if (needToChangeFields) {
    // await getDocumentForJob(null, false);
    // store.dispatch(contractSignPostSignature({contractLoading: true})); // check if needed
    // let receiptPagesCount = 0; // we have a new function for it, if needed to be uncommented
    // const receipt = await getCurrentReceipt(null, null);
    // console.log("window.receiptPages", window.receiptPages);
    // console.log("receipt", receipt);
    // debugger;//eslint-disable-line
    // if (receiptPagesCount) {
    //   let newFields = {};
    //   Object.keys(postData.customFieldValues).forEach(key => {
    //     newFields[+key + receiptPagesCount] = postData.customFieldValues[key];
    //   });
    //   postData = Object.assign({}, postData, {customFieldValues: newFields});
    //   store.dispatch(contractSigningSetCustomFields(postData.customFieldValues));
    // }
  }

  await saveQuote({submit: true, showReceipt: false}); // update job contract fields

  JsonApi.contractSign(postData)
    .then(result => {
      const {documentUrl, errors} = result.data;
      loaderDisable();
      store.dispatch(contractSignPostSignature({
        step: 3,
        signedDocumentUrl: documentUrl,
        contractLoading: false
      }));
      if (errors && errors[0]) {
        renderErrorPopup(errors[0], "", offlineRetryCallback);
      }
    })
    .catch(error => {
      renderErrorPopup(error, "", offlineRetryCallback);
      loaderDisable();
      store.dispatch(contractSignPostSignature({
        contractLoading: false
      }));
    })
}

export const getDocumentForJob = async (jobId = null, fromPostSignContract = false) => {
  // changed forceNew to be true by the default, we need a new receipt after job is saved! with the new cart items
  const {serverState, contractSigningState} = store.getState();
  try {
    jobId = jobId || document.kvConfig.jobId || serverState.jobId || +localStorage.getItem('finger-sign-job-id');
  } catch (ex) { console.log("localStorage exception", ex); }

  store.dispatch(contractSignPostSignature({contractLoading: true}));

  loaderEnable("loader.contractSignMessage", "loader.contractSignTitle");

  // if forceNew is true - it will generate a new contract with new receipt
  return JsonApi.getDocumentForJob(jobId, contractSigningState.needToUpdateContract)
    .then(async result => {
      if (!fromPostSignContract) {
        loaderDisable();
      }
      if (result && result.data && !result.data.invoiceNumberOfPages) {
        const pdfReceiptPagesLength = await getCurrentReceiptPages();
        console.log("shifting receipt pages", pdfReceiptPagesLength);
        result.data.invoiceNumberOfPages = pdfReceiptPagesLength;
      }
      store.dispatch(setContractDocumentForJob(result.data));
      store.dispatch(contractSignPostSignature({contractLoading: false}));
      return result
    })
    .catch(async (error) => {
      if (IS_OFFLINE_MODE && contractSigningState.contractBlob) {
        const responseFetch = await fetch(contractSigningState.contractBlob);
        const blob = await responseFetch.blob();
        console.log("getDocumentForJob catch", blob);
        const jobDocumentUrl = URL.createObjectURL(blob);
        console.log("createdBlobDocument", jobDocumentUrl);
        store.dispatch(setContractDocumentForJob({
          jobDocumentUrl,
        }));
      }
      if (!fromPostSignContract) {
        loaderDisable();
      }
      console.error(error);
    })
}

/**
 * new
 * */
export const postSaveContracts = async (offlineRetryCallback, history) => {
  const {contractSigningState, assignQuoteState} = store.getState();

  // if (!contractSigningState.contractsList.length || IS_AS_WORK_ORDER) {
  //   loaderEnable("loader.savingQuoteText", "loader.appointmentTitle");
  // } else {
    loaderEnable("loader.contractSignText", "loader.contractSignTitle");
  // }

  const {userState, serverState} = store.getState();

  const hasContractCallBack = !document.kvConfig.jobId && contractSigningState.afterContractSignCallback;

  if (hasContractCallBack) {
    try {
      const responseSaveQuote = await contractSigningState.afterContractSignCallback();
      // here we registered customer and saved quote
      console.log("responseSaveQuote", responseSaveQuote);

      if (responseSaveQuote) {
        store.dispatch(setAfterContractSignCallback(null)); // erase it, it's ok now
      } else {
        setTimeout(() => {
          const {userState} = store.getState();
          if (!(userState.confirmPopupOpened && userState.confirmPopupType === ConfirmPopupTypes.AssignQuoteOnExistingUser)) {
            renderErrorPopup("Network Error", "", offlineRetryCallback); // overwrite existing popup!
          }
        }, 0)
        return // do not go further, quote is not saved
      }
    } catch (error) {
      renderErrorPopup(error, "", offlineRetryCallback);
      loaderDisable();
      return // do not go further, quote is not saved
    }
  }

  const customerEmail = (assignQuoteState.assignQuotePopupCustomer ? assignQuoteState.assignQuotePopupCustomer.email : null)
    || userState.email || userState.userInfo.email;

  if (!customerEmail) {
    renderErrorPopup("The job is not saved, check customer data", "");
    loaderDisable();
    return
  }

  let jobId = document.kvConfig.jobId || serverState.jobId;
  if (!(hasContractCallBack && jobId)) { // job is saved already
    //always save, we need to paas contract fields on backend
    const savedSuccess = await saveQuote({submit: true, showReceipt: false}); // update job contract fields
    if (savedSuccess) {
      jobId = savedSuccess.jobId;
    }
  }

  if (!contractSigningState.contractsList.length || IS_AS_WORK_ORDER) {
    if (history) {
      history.push("/shoppingcart");
    }
    //should we show order complete if contract wasn't signed?
    store.dispatch(showOrderCompletePopup(true));
    return
  }

  let DocumentValueDict = {};
  Object.keys(contractSigningState.contractsValues).forEach(contractId => {
    DocumentValueDict[contractId] = {
      Replacements: {}, // to do? replace what?
      CustomFieldValues: contractSigningState.contractsValues[contractId]
    }
  })

  let postData = {
    fabricatorId: document.kvConfig.userId,
    jobId,
    customerEmail,
    DocumentValueDict,
    contractFieldValuesOnly: contractSigningState.jobDocumentUrl ? contractSigningState.jobDocumentUrl.includes("blob:") : false,
  };

  JsonApi.contractSign(postData)
    .then(result => {
      const {documentUrl, errors} = result.data;
      loaderDisable();
      store.dispatch(contractSignPostSignature({
        step: 3,
        signedDocumentUrl: documentUrl,
        contractLoading: false
      }));
      if (errors && errors[0]) {
        renderErrorPopup(errors[0], "", offlineRetryCallback);
      } else {
        Analytics.sendClickEvent("contract-signed-ok");
      }
    })
    .catch(error => {
      renderErrorPopup(error, "", offlineRetryCallback);
      loaderDisable();
      store.dispatch(contractSignPostSignature({
        contractLoading: false
      }));
    })
}
